import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";
import { disableConfigData } from "src/_constants/roleType";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
@Component({
  selector: "app-setting-management",
  templateUrl: "./setting-management.component.html",
  styleUrls: ["./setting-management.component.scss"],
})
export class SettingManagementComponent implements OnInit {
  updateForm: FormGroup;
  loading = false;
  submitted = false;
  btnDisable = true;
  OperatorId: "";
  ConfigData;
  data;
  selectedProvider = "BetFair";
  disableConfigData = disableConfigData;
  public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));

  constructor(
    private formBuilder: FormBuilder,
    private appService: AppService,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    this.getData();
  }
  getData() {
    try {
      this.appService.getOperatorData().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.data = res.operators;
          let operatorData = res.operator[0];
          (this.ConfigData = operatorData.config),
            (this.OperatorId = operatorData.operator_id),
            (this.updateForm = this.formBuilder.group({
              OperatorId: [operatorData.operator_id, Validators.required],
              OperatorName: [operatorData.operator_name, Validators.required],
              BaseURL: [operatorData.base_url, Validators.required],
              PublicKey: [operatorData.publicKey, Validators.required],
              WalletType: [operatorData.wallet_type, Validators.required],
              OperatorKey: [operatorData.operatorKey, Validators.required],
              PrivateKey: [operatorData.publicKey, Validators.required],
              Status: [operatorData.status, Validators.required],
              hold: [operatorData.config.hold, Validators.required],
            }));
        }
      });
    } catch (err) {}
  }
  get f() {
    return this.updateForm.controls;
  }

  onChangeProvider = (pid) => {
    this.selectedProvider = pid;
  };

  getDelaySecounds(sec: number) {
    return sec < 10 ? sec * 1000 : sec;
  }

  onSubmit() {
    if (this.ConfigData.hold > 100) {
      return this.appService.openErrorBar("Hold should not exceed 100");
    } else {
      let cData = this.ConfigData;
      for (let i in cData) {
        if (typeof cData[i] === "object" && cData[i].delay) {
          let d = (this.getDelaySecounds(cData[i].delay) * 1000).toFixed(1);
          cData[i] = { ...cData[i], delay: Number(d) };
        }
      }
      let editData = {
        OperatorId: this.f.OperatorId.value,
        OperatorName: this.f.OperatorName.value,
        BaseURL: this.f.BaseURL.value,
        Status: this.f.Status.value,
        WalletType: this.f.WalletType.value,
        Keys: {
          PrivateKey: this.f.OperatorKey.value,
          PublicKey: this.f.PrivateKey.value,
          OperatorKey: this.f.OperatorKey.value,
        },
        config: cData,
      };
      try {
        this.appService.replaceOperators(editData).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.getData();
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
      } catch (err) {}
    }
  }

  handleChange(event, provider) {
    this.btnDisable = false;
    const { target } = event;
    const { name, value } = target;
    let cData = this.ConfigData;
    if (typeof cData[provider] === "object")
      cData[provider][name] = value ? parseFloat(value) : "";
    else cData[provider] = value ? parseFloat(value) : "";
    this.ConfigData = cData;
    return true;
  }
  returnZero() {
    return 0;
  }

  handleCopyText = (val: string) => {
    if (val === "PublicKey") {
      let selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = this.f.PrivateKey.value;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);
    } else {
      let selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = this.f.OperatorKey.value;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);
    }
  };
}
